import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { routes } from "@/common/utils/routes";
import { useGeolocationStore } from "@/common/store/geolocationStore";

interface IStateMapping {
  state: string;
  allowedPages: string[];
}

const COMMON_ALLOWED_PAGES = [
  "/guidelines",
  "/ifr/"
];

export const STATE_MAPPINGS: IStateMapping[] = [
  { state: "alabama", allowedPages: ["/alabama-slate", ...COMMON_ALLOWED_PAGES] },
  { state: "florida", allowedPages: ["/florida-slate", ...COMMON_ALLOWED_PAGES] },
  { state: "indiana", allowedPages: ["/indiana-slate", ...COMMON_ALLOWED_PAGES] },
  { state: "kansas", allowedPages: ["/kansas-slate", ...COMMON_ALLOWED_PAGES] },
  { state: "louisiana", allowedPages: ["/louisiana-slate", ...COMMON_ALLOWED_PAGES] },
  { state: "oklahoma", allowedPages: ["/oklahoma-slate", ...COMMON_ALLOWED_PAGES] },
  { state: "tennessee", allowedPages: ["/tennessee-slate", ...COMMON_ALLOWED_PAGES] },
  { state: "texas", allowedPages: ["/texas-slate", ...COMMON_ALLOWED_PAGES] },
];

export const useGeoBlockedPage = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const blockedState = useGeolocationStore((state) => state.blockedState);

  useEffect(() => {
    if (!blockedState) {
      return;
    }

    const mapping = STATE_MAPPINGS.find(({ state }) => state === blockedState);

    if (!mapping) {
      return;
    }

    const isAllowedPage = mapping.allowedPages.some(page => location.pathname.includes(page));

    if (!isAllowedPage) {
      navigate(routes.geoBlockedPage(mapping.state));
    }
  }, [location.pathname, navigate, blockedState]);
};
